import Xt from "../models/backend-errors.js";
import ve from "../models/braze-event.js";
import {
  convertMsToSeconds as h,
  convertSecondsToMs as Kt,
} from "../util/date-utils.js";
import t from "../common/event-logger.js";
import { isArray as j, isEqual as ii } from "../util/code-utils.js";
import { logger as r, EventTypes as i } from "../../shared-lib/index.js";
import { STORAGE_KEYS as o } from "./storage-manager.js";
import D from "../util/request-header-utils.js";
import { LAST_REQUEST_TO_ENDPOINT_MS_AGO_DEFAULT as Ht } from "../common/constants.js";
import { getAlias as Yt } from "./utils.js";
export default class Pt {
  constructor(t, e, i, s, r, n, o, h, a, u, l, c) {
    (this.on = t),
      (this.u = e),
      (this.Ko = i),
      (this.yt = s),
      (this.oi = r),
      (this.qt = n),
      (this.rn = o),
      (this.Go = h),
      (this.Bo = a),
      (this.Vo = u),
      (this.appVersion = l),
      (this.Xh = c),
      (this.Hh = (t) => (null == t ? "" : `${t} `)),
      (this.on = t),
      (this.u = e),
      (this.Ko = i),
      (this.yt = s),
      (this.oi = r),
      (this.qt = n),
      (this.rn = o),
      (this.Go = h),
      (this.Bo = a),
      (this.Vo = u),
      (this.appVersion = l),
      (this.Xh = c),
      (this.Yh = ["npm"]);
  }
  $s(t, e = !1, i = !1) {
    const s = this.on.ce(!i),
      r = s.Mr(),
      n = this.u.j(o.C.Fa);
    ii(n, r) || (t.device = r),
      (t.api_key = this.rn),
      (t.time = h(new Date().valueOf(), !0));
    const a = this.u.j(o.C.Jh) || [],
      u = this.u.j(o.C.Qh) || "";
    if (
      (this.Yh.length > 0 &&
        (!ii(a, this.Yh) || u !== this.oi.xi()) &&
        (t.sdk_metadata = this.Yh),
      (t.sdk_version = this.Bo),
      this.Vo && (t.sdk_flavor = this.Vo),
      (t.app_version = this.appVersion),
      (t.app_version_code = this.Xh),
      (t.device_id = s.id),
      e)
    ) {
      const e = this.yt.getUserId();
      null != e && (t.user_id = e);
    }
    if (!t.user_id && !this.Ko.Fh()) {
      const e = Yt(this.u);
      e && (t.alias = e);
    }
    return t;
  }
  Qs(e, s, n) {
    const o = s.auth_error,
      h = s.error;
    if (!o && !h) return !0;
    if (o) {
      let t;
      this.Ko.Bh();
      const i = { errorCode: o.error_code };
      for (const t of n)
        j(t) && "X-Braze-Auth-Signature" === t[0] && (i.signature = t[1]);
      e.respond_with && e.respond_with.user_id
        ? (i.userId = e.respond_with.user_id)
        : e.user_id && (i.userId = e.user_id);
      const s = o.reason;
      return (
        s
          ? ((i.reason = s), (t = `due to ${s}`))
          : (t = `with error code ${o.error_code}.`),
        this.Ko.Fh() ||
          (t +=
            ' Please use the "enableSdkAuthentication" initialization option to enable authentication.'),
        r.error(`SDK Authentication failed ${t}`),
        this.Zh(e.events || [], e.attributes || []),
        this.Ko.qh(i),
        !1
      );
    }
    if (h) {
      let n,
        o = h;
      switch (o) {
        case Xt.Ra:
          return (
            (n = "Received successful response with empty body."),
            t.q(i.Ls, { e: n }),
            r.info(n),
            !1
          );
        case Xt.Ba:
          return (
            (n = "Received successful response with invalid JSON"),
            t.q(i.Ls, { e: n + ": " + s.response }),
            r.info(n),
            !1
          );
        case Xt.Na:
          o = `The API key "${e.api_key}" is invalid for the baseUrl ${this.Go}`;
          break;
        case Xt.Xa:
          o =
            "Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.";
          break;
        case Xt.$a:
          o = "No device identifier. Please contact support@braze.com";
      }
      r.error("Backend error: " + o);
    }
    return !1;
  }
  La(t, e, i, s) {
    return !!((t && 0 !== t.length) || (e && 0 !== e.length) || i || s);
  }
  Ea(t, e, i, s, r = !1) {
    const n = [],
      o = (t) => t || "",
      h = o(this.yt.getUserId());
    let a = this.Ir(t, e);
    const u = [],
      l = [];
    let c,
      d = null;
    if (i.length > 0) {
      const t = [];
      for (const e of i) {
        if (((c = e.Mr()), this.Ko.Fh())) {
          if (h && !c.user_id) {
            d || (d = {}), d.events || (d.events = []), d.events.push(c);
            continue;
          }
          if (o(c.user_id) !== h) {
            l.push(c);
            continue;
          }
        }
        t.push(c);
      }
      t.length > 0 && (a.events = t);
    }
    if (s.length > 0) {
      const t = [];
      for (const e of s)
        e && (this.Ko.Fh() && o(e.user_id) !== h ? u.push(e) : t.push(e));
      t.length > 0 && (a.attributes = t);
    }
    if ((this.Zh(l, u), (a = this.$s(a, !0, r)), d)) {
      d = this.$s(d, !1, r);
      const t = { requestData: d, headers: this.Ps(d, D._s.Ka) };
      n.push(t);
    }
    if (a && !this.La(a.events, a.attributes, t, e)) return d ? n : null;
    const f = { requestData: a, headers: this.Ps(a, D._s.Ka) };
    return n.push(f), n;
  }
  Zh(t, e) {
    if (t) {
      const e = [];
      for (const i of t) {
        const t = ve.fromJson(i);
        (t.time = Kt(t.time)), e.push(t);
      }
      this.u.zo(e);
    }
    if (e) for (const t of e) this.u.Pa(t);
  }
  Ys(t, e) {
    let i = "HTTP error ";
    null != t && (i += t + " "), (i += e), r.error(i);
  }
  qr(e) {
    return t.q(i.Ua, { n: e });
  }
  Ir(t, e, i) {
    const s = {};
    t && (s.feed = !0), e && (s.triggers = !0);
    const r = null != i ? i : this.yt.getUserId();
    if ((r && (s.user_id = r), !s.user_id && !this.Ko.Fh())) {
      const t = Yt(this.u);
      t && (s.alias = t);
    }
    return (s.config = { config_time: this.qt.hi() }), { respond_with: s };
  }
  Ha(t) {
    const e = new Date().valueOf();
    let i = Ht.toString();
    const s = D.Wa(this.u, t);
    if (-1 !== s) {
      i = (e - s).toString();
    }
    return i;
  }
  Ps(t, e, i = !1) {
    const s = [["X-Braze-Api-Key", this.rn]],
      r = this.Ha(e);
    s.push(["X-Braze-Last-Req-Ms-Ago", r]);
    const n = D.Ya(this.u, e).toString();
    s.push(["X-Braze-Req-Attempt", n]);
    let h = !1;
    if (
      (null != t.respond_with &&
        t.respond_with.triggers &&
        (s.push(["X-Braze-TriggersRequest", "true"]), (h = !0)),
      null != t.respond_with &&
        t.respond_with.feed &&
        (s.push(["X-Braze-FeedRequest", "true"]), (h = !0)),
      e === D._s.Xs)
    ) {
      s.push(["X-Braze-ContentCardsRequest", "true"]);
      let t = this.u.j(o.C.xs);
      (t && i) || ((t = 0), this.u.I(o.C.xs, t)),
        s.push(["BRAZE-SYNC-RETRY-COUNT", t.toString()]),
        (h = !0);
    }
    if (
      (e === D._s.Ri &&
        (s.push(["X-Braze-FeatureFlagsRequest", "true"]), (h = !0)),
      h && s.push(["X-Braze-DataRequest", "true"]),
      this.Ko.Fh())
    ) {
      const t = this.Ko.kh();
      null != t && s.push(["X-Braze-Auth-Signature", t]);
    }
    return s;
  }
  Ja(t, e, i, s) {
    window.setTimeout(() => {
      r.info(`Retrying rate limited ${this.Hh(s)}SDK request.`),
        this.Gs(e, i, s);
    }, t);
  }
  Gs(t, e, i, s) {
    if (!this.Qa(i))
      return (
        r.info(`${this.Hh(i)}SDK request being rate limited.`),
        void ("function" == typeof s && s())
      );
    const n = this.Va();
    if (!n.Za)
      return (
        r.info(
          `${this.Hh(
            i,
          )}SDK request being rate limited. Request will be retried in ${Math.trunc(
            n.au / 1e3,
          )} seconds.`,
        ),
        void this.Ja(n.au, t, e, i)
      );
    this.u.I(o.C.du, new Date().valueOf());
    const h = t.device;
    h && h.os_version instanceof Promise
      ? h.os_version.then((i) => {
          (t.device.os_version = i), e(n.fu);
        })
      : e(n.fu);
  }
  vu(t) {
    var e;
    null === (e = this.u) || void 0 === e || e.I(o.C.Ru, t);
  }
  gu(t, e) {
    let i = this.pu();
    null == i && (i = {}), (i[t] = e), this.u.I(o.C.bu, i);
  }
  qu() {
    var t;
    return null === (t = this.u) || void 0 === t ? void 0 : t.j(o.C.Ru);
  }
  pu() {
    var t;
    return null === (t = this.u) || void 0 === t ? void 0 : t.j(o.C.bu);
  }
  Au(t, e, i, s, r = "") {
    let n;
    if (r) {
      const t = this.pu();
      n = null == t || isNaN(t[r]) ? e : t[r];
    } else (n = this.qu()), (null == n || isNaN(n)) && (n = e);
    const o = (t - s) / 1e3;
    return (n = Math.min(n + o / i, e)), n;
  }
  Du(t, e) {
    return Math.max(0, (1 - t) * e * 1e3);
  }
  Tu(t, e = "") {
    var i, s, r, n, h;
    const a = { Za: !0, fu: -1, au: 0 };
    if ((null == t && (t = !0), !t && !e)) return a;
    let u,
      l,
      c = null;
    if (t) c = null === (i = this.u) || void 0 === i ? void 0 : i.j(o.C.du);
    else {
      const t = D.ku(this.u);
      if (null == t || null == t[e]) return a;
      c = t[e];
    }
    if (null == c || isNaN(c)) return a;
    if (
      (t
        ? ((u =
            (null === (s = this.qt) || void 0 === s ? void 0 : s.Cu()) || -1),
          (l =
            (null === (r = this.qt) || void 0 === r ? void 0 : r.Su()) || -1))
        : ((u =
            (null === (n = this.qt) || void 0 === n ? void 0 : n.Bu(e)) || -1),
          (l =
            (null === (h = this.qt) || void 0 === h ? void 0 : h.wu(e)) || -1)),
      -1 === u || -1 === l)
    )
      return a;
    const d = new Date().valueOf();
    let f = this.Au(d, u, l, c, e);
    return f < 1
      ? ((a.Za = !1), (a.au = this.Du(f, l)), a)
      : ((f = Math.trunc(f) - 1),
        (a.fu = f),
        t ? this.vu(f) : this.gu(e, f),
        a);
  }
  Va() {
    return this.Tu(!0);
  }
  Qa(t) {
    const e = this.Tu(!1, t);
    return !(e && !e.Za);
  }
  Vs() {
    this.Ko.Vs();
  }
  Os() {
    return this.Go;
  }
  addSdkMetadata(t) {
    for (const e of t) -1 === this.Yh.indexOf(e) && this.Yh.push(e);
  }
}
